import cx from 'classnames'
import { type TStyleVariantProps } from './types'
import { HorizontalStyleVariant } from './HorizontalStyleVariant'

// 255px / 375px = 68%

// screen width  |  paddings plus gaps between tiles  |            tile width               |
//     744px     |   48px + 48px + 2 * 16px = 128px   |  (100vw-160px)/3 = 33.33vw-42.66px  |
//    1024px     |   48px + 48px + 3 * 16px = 144px   |  (100vw-144px)/4 = 25vw-36px        |
//    1440px     |   48px + 48px + 4 * 16px = 160px   |  (100vw-160px)/5 = 20vw-32px        |
//    1920px     |   48px + 48px + 5 * 16px = 176px   |  (100vw-176px)/6 = 16.66vw-29.33px  |

export const LargeStyleVariant = ({ className, children }: TStyleVariantProps) => (
  <HorizontalStyleVariant
    className={cx(
      '*:aspect-[1/1.186]',
      '*:w-[68vw]',
      '744:*:w-[calc((100vw-128px)/3)]',
      '1024:*:w-[calc((100vw-144px)/4)]',
      '1440:*:w-[calc((100vw-160px)/5)]',
      '1920:*:w-[calc((100vw-176px)/6)]',
      className
    )}
  >
    {children}
  </HorizontalStyleVariant>
)
